import { DIALOG_TYPE, LayoutConfig } from '@spartacus/storefront';
import { KbSaveCartDialogComponent } from '../customcomponents/kb-cart/kb-cart-details/kb-save-cart-dialog/kb-save-cart-dialog.component';
import { AddToCartDialogComponent } from '../customcomponents/kb-product-list/added-to-cartdialog/added-to-cartdialog.component';

export const CustomLayoutConfig: LayoutConfig = {
  layoutSlots: {
    LandingPage2Template: {
      slots: ['Section1', 'Section2C', 'Section5'],
    },
    MyAccountPageTemplate: {
      slots: ['BodyContent'],
    },
    SearchResultsListPageTemplate: {
      slots: ['ProductLeftRefinements', 'SearchResultsListSlot'],
    },
    LoginPageTemplate: {
      slots: ['LeftContentSlot', 'SideContent', 'BodyContent'],
    },
    SmartirePageTemplate: {
      slots: ['smartireSlot'],
    },
    QuickOrderPageTemplate: {
      slots: ['BodyContent']
    },
    WarrantyInfoPageTemplate: { slots: ['BodyContent'] },
    BendixADBPageTemplate: { slots: ['BodyContent'] },
    CoreInfoPageTemplate: { slots: ['Section1', 'Section2C', 'Section5'] },
    SoftwarePageTemplate: { slots: ['BodyContent'] },
    SoftwareLibrarySearchPageTemplate: { slots: ['BodyContent'] },
    DocumentLibrarySearchPageTemplate: { slots: ['BodyContent'] },
    SteeringGearSearchPageTemplate: { slots: ['BodyContent'] },
    FormulaBlueSearchPageTemplate: { slots: ['BodyContent'] },
    OneTrustTemplate: { slots: ['BodyContent'] },
    QuoteEditPageTemplate: { slots: ['BodyContent'] },
    ProductListPageTemplate: { slots: ['ProductLeftRefinements', 'ProductListSlot'] },
    ContentPage1Template: { slots: ['BodyContent'] },
    DTCSearchPageTemplate: { slots: ['BodyContent'] },
    privacyPolicyTemplate: { slots: ['privacyNoteSlot'] }
  },
  launch: {
    ADDED_TO_CART: {
      inlineRoot: true,
      component: AddToCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
    SAVED_CART: {
      inlineRoot: true,
      component: KbSaveCartDialogComponent,
      dialogType: DIALOG_TYPE.DIALOG,
    },
  },
};
